import { Trans } from "react-i18next"

import util from "utils/utils"

const ProjectIdeaMoved = ({ events, ownerIdea = { name: "Undefined" } }) => {
  return (
    <Trans i18nKey="notifications.projectIdeaMoved">
      <b>{{ name: util.getEventNames(events) }}</b>
      has moved the idea
      <b>{{ idea: ownerIdea.name }}</b>
      from the
      <b>{{ prevStage: events[0]?.previousLane }}</b>
      stage to the
      <b>{{ newStage: events[events.length - 1]?.newLane }}</b>
      stage
    </Trans>
  )
}

export default ProjectIdeaMoved
